// team.js
export const team = [
  {
    id: 1,
    name: "Dr. Ayesha Khan",
    role: "CEO",
    image: "https://via.placeholder.com/150"
  },
  {
    id: 2,
    name: "Mr. Bilal Ahmed",
    role: "Head of Management",
    image: "https://via.placeholder.com/150"
  }
];
